// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3H6gY","label":"styles_label__20Sxc"};